// --- LAYOUT, COMPONENTS, PARTS --- //
$(function(){
	// ---  LAYOUT --- //

	// ---  COMPONENTS --- //
	fn_components_fullscreen_navigation();
	fn_components_google_map();
	fn_components_slider();
	fn_components_select();
	fn_components_gallery();
	fn_components_counter();
	fn_components_calendar(); 
	fn_components_modal();


	// ---  PARTS --- //
	// fn_parts_navigation_scroll_resize();
	fn_parts_placeholder();
});


// --- MISC --- //
$(function () {
	nl_fn_scroll_to();
});

// --- EVENTS --- //
$(window).resize(function(){
	fn_checkNavigationTrigger();
	// fn_parts_navigation_scroll_resize();
});

$(document).scroll(function () {
	// fn_parts_navigation_scroll_resize();
});


$(window).bind('load', function () {
	fn_parts_dots();
});
